import { Repeat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionHeader } from "@/components/ui/section-header";

type PageSectionHeaderProps = {
  title: string;
  /** Muted "· meta" text after the title. */
  meta: string;
  /** Show the repeat mark: the section runs more than once. */
  repeats: boolean;
  repeatedLabel: string;
  addLabel: string;
  /** Omitted for a section that takes no new pages: the button is left out. */
  onAdd?: () => void;
};

/**
 * QL-117 — the header strip of one page section: its label (with a repeat mark when the
 * section runs more than once) on the left, its own Add Page button on the right. Where a new
 * page lands follows from which strip's button was pressed. A thin wrapper over the shared
 * `SectionHeader` strip variant.
 */
export function PageSectionHeader({
  title,
  meta,
  repeats,
  repeatedLabel,
  addLabel,
  onAdd,
}: PageSectionHeaderProps) {
  return (
    <SectionHeader
      variant="strip"
      title={
        <span className="inline-flex items-center gap-2">
          {title}
          {repeats && (
            <Repeat
              className="h-3.5 w-3.5 shrink-0 text-muted-foreground"
              aria-label={repeatedLabel}
              role="img"
            />
          )}
        </span>
      }
      description={meta || undefined}
      action={
        onAdd && (
          <Button onClick={onAdd} size="sm" variant="outline">
            {addLabel}
          </Button>
        )
      }
    />
  );
}
